import { useCallback, useEffect } from 'react';
import { isNil } from 'lodash-es';
import { useSelector } from 'react-redux';
import { manageEvent } from './eventHandlers/eventHandlerManager';
import { useGetAccessTokenMutation, useGetMeQuery } from '../../store/users/usersApi';
import { selectCsrfToken } from '../../store/shared/selectors/auth.selectors';

export function useUserSse(): void {
	const [getAccessToken] = useGetAccessTokenMutation();
	const { data: user } = useGetMeQuery();
	const csrfToken = useSelector(selectCsrfToken);

	const openStream = useCallback(async (): Promise<void> => {
		if (isNil(user) || (user?.customData?.principalKind === 'GUEST' && isNil(csrfToken))) {
			return;
		}

		try {
			// 2) Ask server for stream token
			const res = await getAccessToken().unwrap();

			const { token, expiresAt } = res;

			// 3) Open SSE
			const url = `${process.env.REACT_APP_SERVER_ENDPOINT}/api/users/stream/${encodeURIComponent(user.id)}?token=${encodeURIComponent(token)}`;

			const es = new EventSource(url); // EventSource never sends auth headers; token in query is fine

			es.onmessage = (evt): void => {
				try {
					const parsed = JSON.parse(evt.data);

					manageEvent(parsed);
				} catch {
					/* ignore */
				}
			};

			es.onerror = (e): void => {
				// CORS/401/closed connection leads here
				const delay = 5_000;

				console.log('error', e);

				window.setTimeout(() => openStream(), delay);
			};

			// 4) Proactive renew
			if (!isNil(expiresAt)) {
				// TODO
			}
		} catch (e) {
			console.error('Error setting up user SSE', e);
		}
	}, [csrfToken, getAccessToken, user]);

	useEffect(() => {
		openStream();
	}, [openStream]);
}
